// extracted by mini-css-extract-plugin
export default {"main":"Checkbox_main__19SKb","label":"Checkbox_label__uHskK"};